import React from 'react';
import { Snackbar } from '@material-ui/core';
import MuiAlert, {AlertProps} from '@material-ui/lab/Alert';

interface MyAlertProps extends AlertProps{
    open: boolean,
    duration?: number,
    onClose?: () => void,
    message: string,
}

function AlertMaterialUi(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Alert: React.FC<MyAlertProps> = ({
    open = true,
    onClose,
    duration = 3000,
    severity,
    message
}) => {
    return(
        <Snackbar open={open} autoHideDuration={duration} onClose={onClose}>
            <AlertMaterialUi onClose={onClose} severity={severity}>
                {message}
            </AlertMaterialUi>
        </Snackbar>
    );
}

export default Alert;